<div>
  <div class="title">{{ title }}</div>
  <span>{{ message }}</span>
</div>
<button type="button" *ngIf="options.closeButton" class="close-button"></button>
